export default {
    calendar: {
        items: []
    }
};
